import { render } from "./PrivacyPolicyForm.vue?vue&type=template&id=078ebd0e&scoped=true"
import script from "./PrivacyPolicyForm.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyForm.vue?vue&type=script&lang=ts"

import "./PrivacyPolicyForm.vue?vue&type=style&index=0&id=078ebd0e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-078ebd0e"

export default script